export default "__VITE_ASSET__DdimBpRO__"